import React from "react";
import TodoList from "./TodoList";
import { connect } from "react-redux";
import "./TodoApp.scss";
import {
  Add_Todo,
  Delete_Checkbox,
  Get_List_Todo,
  Update_Checkbox,
} from "../../actions_agent/Todo_action";
import { change_Lang } from "../../actions/Helper_action";
class TodoApp extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      text: "",
      done: false,
    };
  }
  componentDidMount() {
    this.props.Get_List_Todo();
  }

  handleTextChange = (event) => {
    this.setState({
      text: event.target.value,
    });
  };
  handleAddItem = (event) => {
    event.preventDefault();
    let user = JSON.parse(localStorage.getItem("user"));
    const newItem = {
      todo: this.state.text,
      done: false,
    };
    this.props.Add_Todo(user.branchId._id, newItem);
    this.setState({
      items: [...this.props.items, newItem],
      text: "",
    });
  };
  markItemCompleted = (itemId) => {
    const updatedItems = this.props.items.map((item) => {
      if (itemId === item._id) item.done = !item.done;
      return item;
    });
    this.props.Update_Checkbox(itemId);
    // State Updates are Merged
    this.setState({
      items: [this.props.items, updatedItems],
    });
  };

  handleDeleteItem = (itemId) => {
    const updatedItems = this.props.items.filter((item) => {
      return item._id !== itemId;
    });
    this.props.Delete_Checkbox(itemId);
    this.props.Get_List_Todo();
    this.setState({
      items: [this.props.items, updatedItems],
    });
  };
  render() {
    return (
      <div className="mb-4 container-fluid">
        <div className="row">
          <div className="col-md-12">
            <TodoList
              items={this.props.items}
              onItemCompleted={this.markItemCompleted}
              onDeleteItem={this.handleDeleteItem}
              change_Lang={this.props.change_Lang}
              lang={this.props.lang}
            />
          </div>
        </div>
        <br />
        <form className="row" style={{ background: "white" }}>
          <div className="col-md-9">
            <input
              type="text"
              className="form-control"
              onChange={this.handleTextChange}
              value={this.state.text}
              autoComplete="off"
            />
          </div>
          <div className="col-md-2">
            <button
              className="btn  btn-sm px-2 py-2  exp_btn"
              onClick={this.handleAddItem}
            >
              {"Add #" + (this.props.items.length + 1)}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const MapStateToProps = (state) => {
  return {
    items: state.TodoApp_Reducer.items,
    lang: state.HelperReducer.lang,
  };
};

const MapDispatchToProps = (dispatch) => {
  return {
    Get_List_Todo: () => dispatch(Get_List_Todo()),
    Add_Todo: (bid, data) => dispatch(Add_Todo(bid, data)),
    change_Lang: (key) => dispatch(change_Lang(key)),
    Update_Checkbox: (id) => dispatch(Update_Checkbox(id)),
    Delete_Checkbox: (id, data) => dispatch(Delete_Checkbox(id, data)),
  };
};
export default connect(MapStateToProps, MapDispatchToProps)(TodoApp);
